<template>
  <div
    class="rs-sidebar-card-inbox"
    :class="cardClasses"
    @click="$emit('click')"
  >
    <Fragment v-if="lead == true">
      <div class="rs-sidebar-card-inbox__upper">
        <div>
          <h3>{{ name }}</h3>
        </div>
        <div class="flex-wrap">
          <RsIcon
            v-if="attachment"
            weight="far"
            icon="paperclip"
          />
          <p class="date">
            {{ date }}
          </p>
        </div>
      </div>
      <div class="rs-sidebar-card-inbox__lower">
        <RsBadge
          v-if="badgeText || type"
          variant="info"
          pill
        >
          {{ setBadge }}
        </RsBadge>
      </div>
    </Fragment>
    <Fragment v-else>
      <div class="rs-sidebar-card-inbox__upper">
        <div>
          <span
            v-if="type"
            class="form-name"
          >{{ type }}</span>
        </div>
        <div class="flex-wrap">
          <RsIcon
            v-if="attachment"
            weight="far"
            icon="paperclip"
          />
          <p class="date">
            {{ date }}
          </p>
        </div>
      </div>
      <div class="rs-sidebar-card-inbox__lower">
        <h3>{{ name }}</h3>
      </div>
    </Fragment>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsSidebarCardInbox',

  props: {
    type: String,
    date: String,
    name: String,
    badgeText: String,
    favorite: {
      type: Boolean,
      default: false,
    },
    providers: Array,
    attachment: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    new: {
      type: Boolean,
      default: false,
    },
    lead: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    setBadge(): string {
      if (this.type === 'inquiry') {
        return 'Website';
      }
      return `${this.badgeText}`;
    },

    cardClasses(): Record<string, boolean> {
      return {
        'rs-sidebar-card-inbox--new': this.new,
        'rs-sidebar-card-inbox--active': this.active,
        'rs-sidebar-card-inbox--lead': this.lead,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.rs-sidebar-card-inbox {
  padding: 0.75rem 1.5rem;
  opacity: 0.5;
  border-bottom: 1px solid $extra-light-gray;
  border-left: 3px solid transparent;
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
  &__upper,
  &__lower{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  h3{
    margin: 0;
    font-size: 0.875rem;
  }
  &__upper{
    position: relative;
    margin-bottom: 0.25rem;
    color: $tertiary-muted;

    .form-name{
      text-transform: uppercase;
      letter-spacing: 1px;
      font-weight: 700;
      font-size: 11px;
      color: rgba($tertiary-muted, 0.5);
    }
    .flex-wrap{
      display: flex;
      align-items: center;
      .rs-icon{
        margin-right: 0.25rem;
        font-size: 12px;
      }
      .date{
        margin: 0;
        font-weight: 700;
        font-size: 12px;
      }
    }
  }

  &--active{
    background-color: rgba(187,195,241, 0.15);
    border-left-color: $secondary-color;
    opacity: 1;
  }
}
</style>
